import React from 'react';
import { motion } from 'framer-motion';
import { Shirt, PersonStanding, Video, Maximize, Wand2, Megaphone, Sparkles, Image, ShieldCheck, Workflow, Users, Plug, Layers, Lock } from 'lucide-react';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

const ICONS = { Shirt, PersonStanding, Video, Maximize, Wand2, Megaphone, Sparkles, Image, ShieldCheck, Workflow, Users, Plug, Layers, Lock };

export default function Features() {
  const { content, locale } = useContent();
  const data = content.features || {};
  const items = data.items || [];

  return (
    <section
      id="features"
      data-testid="features-section"
      className="section bg-bg-secondary border-y border-line relative"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20">
          <div>
            <p className="text-eyebrow mb-4">{pickLocale(data.eyebrow, locale)}</p>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] max-w-3xl" data-testid="features-title">
              {pickLocale(data.title, locale)}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line rounded-md overflow-hidden" data-testid="features-grid">
          {items.map((item, i) => {
            const Ico = ICONS[item.icon] || Sparkles;
            return (
              <motion.article
                key={i}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="bg-bg p-8 md:p-10 group cursor-default tracing-beam relative min-h-[280px] flex flex-col justify-between"
              >
                <div className="flex items-center justify-between mb-8">
                  <div className="w-12 h-12 rounded-md border border-line-strong flex items-center justify-center text-acid group-hover:border-acid transition-colors">
                    <Ico size={20} strokeWidth={1.4} />
                  </div>
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-dim">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl mb-3 text-ink leading-tight">
                    {pickLocale(item.title, locale)}
                  </h3>
                  <p className="text-ink-muted text-sm md:text-[15px] leading-relaxed">
                    {pickLocale(item.description, locale)}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
